import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import posthog from 'posthog-js';
import { map, mergeMap, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserClerkService } from '../core/user/user-clerk.service';

export const authGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const userClerkService = inject(UserClerkService);

  if (!environment.isConnectToBackend) {
    return of(true);
  }

  if (environment.isE2e) {
    const cypressAccessToken = window.localStorage.getItem('CypressAccessToken');
    if (cypressAccessToken) {
      environment.accessToken = cypressAccessToken;
    }
    return of(true);
  }

  return userClerkService.init$().pipe(
    mergeMap(() => {
      return userClerkService.getUser$().pipe(
        map((user) => {
          if (!user) {
            const currentUrl = state.url;

            const navigationExtras: NavigationExtras = {
              queryParams: { fallbackRedirectUrl: currentUrl },
            };

            router.navigate(['/login'], navigationExtras);
            return false;
          }

          userClerkService.userId = user.id;
          posthog.identify(user.id);
          userClerkService.portraitUrl.set(user.imageUrl);
          return true;
        })
      );
    })
  );
};
